var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowLeftIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.02266 11.5063C7.22144 11.2989 7.33301 11.0184 7.33301 10.726C7.33301 10.4337 7.22144 10.1532 7.02266 9.9458L3.2446 5.97266L7.02266 2.05484C7.22144 1.84749 7.33301 1.56698 7.33301 1.2746C7.33301 0.982221 7.22144 0.701719 7.02266 0.49436C6.92345 0.390628 6.80541 0.308294 6.67535 0.252107C6.5453 0.19592 6.4058 0.166992 6.26491 0.166992C6.12402 0.166992 5.98453 0.19592 5.85447 0.252107C5.72442 0.308294 5.60638 0.390628 5.50717 0.49436L0.982031 5.18688C0.881999 5.28976 0.802602 5.41217 0.74842 5.54703C0.694237 5.6819 0.666341 5.82655 0.666341 5.97266C0.666341 6.11876 0.694236 6.26341 0.748419 6.39828C0.802602 6.53314 0.881999 6.65555 0.982031 6.75843L5.50717 11.5063C5.60638 11.61 5.72442 11.6924 5.85447 11.7485C5.98453 11.8047 6.12402 11.8337 6.26491 11.8337C6.4058 11.8337 6.5453 11.8047 6.67535 11.7485C6.80541 11.6924 6.92344 11.61 7.02266 11.5063Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow-left-icon.bb79711f6a2154e3929abf7d40f7508a.svg";
export { ForwardRef as ReactComponent };